import "./IndiaTradeServices.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import ServiceDetails from "./sections/ServiceDetails";
import DetailedServiceLinks from "./sections/DetailedServiceLinks";
import Footer from "@/reusable_sections/Footer";
export default function IndiaTradeServicesPage() {
  return <div>
      <Header />
      <OurServices />
      <ServiceDetails />
      <DetailedServiceLinks />
      <Footer />
    </div>;
}